'use strict';

var ListItem = require('../ListItem');
var getManageLinks = require('../links/manage-links');

function renderManageListItems(depsArg) {
	var manageLinks = getManageLinks.renderManageLinks(depsArg);

	return {

		renderAccountListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderAccountLink(config, deps),
				className: 'ad-component_list-item--account'
			})).render(config, deps);
		},

		renderInsightListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderInsightLink(config, deps),
				className: 'ad-component_list-item--insights'
			})).render(config, deps);
		},

		renderChannelListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderChannelLink(config, deps),
				className: 'ad-component_list-item--channel'
			})).render(config, deps);
		},

		renderCorporateListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderCorporateLink(config, deps),
				className: 'ad-component_list-item--corporate'
			})).render(config, deps);
		},

		renderDeveloperListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderDeveloperLink(config, deps),
				className: 'ad-component_list-item--developer'
			})).render(config, deps);
		},

		renderResellerListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderResellerLink(config, deps),
				className: 'ad-component_list-item--reseller'
			})).render(config, deps);
		},

		renderSuperuserListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: manageLinks.renderSuperuserLink(config, deps),
				className: 'ad-component_list-item--superuser'
			})).render(config, deps);
		}
	};
}

module.exports = {
	renderManageListItems: renderManageListItems
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/manage-list-items.js
// module id = 13
// module chunks = 0